import { ADD_LANGUAGE, DELETE_LANGUAGE, NAVIGATION } from '../types';
import { error, success } from '../utils';

export let initialState = {
  addLanguage: {
    isLoading: false,
    isError: false,
  },
  deleteLanguage: {
    isLoading: false,
    isError: false,
  },
};

const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case ADD_LANGUAGE:
      return {
        ...state,
        addLanguage: {
          isLoading: true,
          isError: false,
        },
      };
    case success(ADD_LANGUAGE):
      return {
        ...state,
        addLanguage: {
          isLoading: false,
          isError: false,
        },
      };
    case error(ADD_LANGUAGE):
      return {
        ...state,
        addLanguage: {
          isLoading: false,
          isError: true,
        },
      };

    case DELETE_LANGUAGE:
      return {
        ...state,
        deleteLanguage: {
          isLoading: true,
          isError: false,
        },
      };
    case success(DELETE_LANGUAGE):
      return {
        ...state,
        deleteLanguage: {
          isLoading: false,
          isError: false,
        },
      };
    case error(DELETE_LANGUAGE):
      return {
        ...state,
        deleteLanguage: {
          isLoading: false,
          isError: true,
        },
      };

    case NAVIGATION:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
